import React, { useCallback, useState } from 'react';
import { parse, format } from 'date-fns';
import { DateTimePicker, Dialog, Flex, PropertyGrid, Text, TextInput } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import { DailyHours } from '@leverege/operating-hours';
import I18N from '@leverege/i18n';
import RangesEditor from "./RangesEditor.js";
import S from './EditOverrideDialog.css';
const {
  t,
  tIcon
} = I18N.ns('imagine.operatingHours.WeeklyHoursEditor');
const DEFAULT_VALUE = DailyHours.create({
  name: 'Holiday',
  open: false,
  ranges: []
});
export default function EditOverrideDialog(props) {
  const {
    show,
    onClose,
    value = DEFAULT_VALUE,
    eventData,
    onChange: pOnChange,
    onMoveDate
  } = props;
  const [sValue, setSValue] = useState(value);
  const [date, setDate] = useState(eventData ? parse(eventData, 'yyyy-MM-dd', new Date()) : new Date());
  const onChange = useCallback(({
    data,
    value: val
  }) => {
    if (data === 'setDate') {
      setDate(val);
      return;
    }
    const nModel = DailyHours[data](value, val);
    setSValue(nModel);
  }, [setSValue, value]);
  const onOkay = useCallback(() => {
    let nValue = sValue;
    nValue = DailyHours.setOpen(nValue, sValue?.ranges.length > 0);
    const formattedDate = format(date, 'yyyy-MM-dd');
    pOnChange({
      data: eventData || formattedDate,
      value: nValue
    });
    if (eventData && formattedDate !== eventData) {
      onMoveDate(eventData, formattedDate);
    }
    onClose?.();
  }, [pOnChange, eventData, sValue, onClose, date, onMoveDate]);
  return /*#__PURE__*/React.createElement(Dialog.Question, {
    variant: "itemForm",
    headerVariant: "itemFormHeader|formHeader",
    bodyVariant: "dialogFormBody|itemFormBody|formBody",
    footerVariant: "itemFormFooter|formButtons",
    okay: "Save",
    title: /*#__PURE__*/React.createElement(TitleBar, {
      variant: "dialogTitle",
      title: t('overrideFormTitle'),
      icon: tIcon('overrideFormIcon', 'fa fa-fw fa-refresh')
    }),
    className: S.dialogBody,
    bodyClassName: S.dialogBody,
    show: show,
    onClose: onClose,
    onOkay: onOkay,
    onCancel: onClose
  }, /*#__PURE__*/React.createElement(PropertyGrid, {
    variant: "overrideEditor",
    vertical: true
  }, /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    fill: true,
    label: t('addDayName')
  }, /*#__PURE__*/React.createElement(Flex, {
    variant: "colS"
  }, /*#__PURE__*/React.createElement(TextInput, {
    onChange: onChange,
    value: DailyHours.getName(sValue),
    eventData: "setName"
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "overrideExample|inputCaptionSmall"
  }, t('addDayNameExample')))), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    fill: true,
    label: t('addDayDate')
  }, /*#__PURE__*/React.createElement(DateTimePicker, {
    variant: "dateOnly",
    format: "MM-DD-YYYY",
    time: false,
    style: {
      zIndex: 1,
      overflow: 'visible'
    },
    value: date,
    eventData: "setDate",
    onChange: onChange
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('whenOpen'),
    fill: true
  }, /*#__PURE__*/React.createElement(RangesEditor, {
    value: sValue,
    model: DailyHours.ranges(),
    onChange: onChange,
    eventData: "setRanges"
  }))));
}